var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4 py-5 sm:px-6",class:[
    _vm.gray ? 'bg-gray-100' : 'border-b border-gray-200',
    _vm.stickToEdgesOnMobile ? 'sm:rounded-t' : 'rounded-t',
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }